import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SectionTitle from "../../components/Common/SectionTitle";

// About Image
import { fetchData, imageBaseURL } from "../../utils/fetchData";
import { JNTUK_API_Urls } from "../../utils/api.config";
import { BlocksRenderer } from "../../components/BlockRenderer";

const AboutText = (props) => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);

  // Helper function to convert child text with modifiers to HTML
  const childToHtml = (child) => {
    if (!child.text) return "";
    
    let text = child.text;
    
    // Apply modifiers
    if (child.bold) text = `<strong>${text}</strong>`;
    if (child.italic) text = `<em>${text}</em>`;
    if (child.underline) text = `<u>${text}</u>`;
    if (child.strikethrough) text = `<del>${text}</del>`;
    if (child.code) text = `<code>${text}</code>`;
    
    return text;
  };

  // Helper function to extract HTML from blocks and truncate
  const getTruncatedText = (blocks, maxLength = 200) => {
    if (!blocks || blocks.length === 0) return "";
    
    let fullHtml = "";
    let textLength = 0;
    let truncated = false;
    
    // Extract HTML from all blocks
    for (const block of blocks) {
      if (truncated) break;
      
      if (block.type === "paragraph" && block.children) {
        let paragraphContent = "";
        
        for (const child of block.children) {
          const childHtml = childToHtml(child);
          const childText = child.text || "";
          
          if (textLength + childText.length > maxLength) {
            const remainingLength = maxLength - textLength;
            const truncatedText = childText.substring(0, remainingLength);
            
            // Apply same modifiers to truncated text
            let truncatedHtml = truncatedText;
            if (child.bold) truncatedHtml = `<strong>${truncatedHtml}</strong>`;
            if (child.italic) truncatedHtml = `<em>${truncatedHtml}</em>`;
            if (child.underline) truncatedHtml = `<u>${truncatedHtml}</u>`;
            if (child.strikethrough) truncatedHtml = `<del>${truncatedHtml}</del>`;
            if (child.code) truncatedHtml = `<code>${truncatedHtml}</code>`;
            
            paragraphContent += truncatedHtml + "...";
            truncated = true;
            break;
          }
          
          paragraphContent += childHtml;
          textLength += childText.length;
        }
        
        fullHtml += `<p>${paragraphContent}</p>`;
        
      } else if (block.type === "heading" && block.children) {
        let headingContent = "";
        
        for (const child of block.children) {
          const childHtml = childToHtml(child);
          const childText = child.text || "";
          
          if (textLength + childText.length > maxLength) {
            const remainingLength = maxLength - textLength;
            const truncatedText = childText.substring(0, remainingLength);
            headingContent += truncatedText + "...";
            truncated = true;
            break;
          }
          
          headingContent += childHtml;
          textLength += childText.length;
        }
        
        const level = block.level || 3;
        fullHtml += `<h${level}>${headingContent}</h${level}>`;
      }
    }
    
    return fullHtml;
  };

  useEffect(() => {
    fetchData(JNTUK_API_Urls["About_JNTUK"], setData);
  }, []);
  useEffect(() => {
    setData2(data?.data?.attributes?.Body?.splice(0, 4));
  }, [data]);
  useEffect(() => {
    setData3(data1?.data?.attributes?.Message?.splice(0, 4));
  }, [data1]);
  useEffect(() => {
    fetchData(JNTUK_API_Urls["Vice_Chancellor"], setData1);
  }, []);

  return (
    <div className="rs-about style1">
      <div className="grphs1 pt-30 pb-30 md-pt-30 md-pb-30">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-5 xl-pl-14 xl-pr-14 xl-mb-30">
              <div className="row">
                <div className="col-md-4 text-center md-mb-20">
                  <div className="img-part">
                    <img
                      className="about-main"
                      src={
                        imageBaseURL +
                        data1?.data?.attributes?.Image?.data?.attributes?.url ||
                        ""
                      }
                      alt={data1?.data?.attributes?.Title}
                      title={data1?.data?.attributes?.Title} style={{height: "250px"}}
                    />
                    <div className="info-part text-center mt-14">
                      <h4
                        className="white"
                        title={data1?.data?.attributes?.Title}
                      >
                        {data1?.data?.attributes?.Title}
                      </h4>
                      <div className="exInfo">
                        <BlocksRenderer
                          content={data1?.data?.attributes?.Sub_Title || []}
                        />
                      </div>
                      {/* <div className="exInfo white">Hon'ble Vice-Chancellor</div>
                <div className="exInfo white">JNTUK, Anantapur</div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="about-content">
                    {/* Section Title Start */}
                    <SectionTitle
                      sectionClass="sec-title"
                      subtitleClass="sub-title orange text-capitalize"
                      subtitle="Vice-Chancellor's Message"
                      titleClass=""
                      title=""
                      descClass=""
                      description=""
                    />
                    <div 
                      className="vice-chancellor-message"
                      dangerouslySetInnerHTML={{ __html: getTruncatedText(data3, 800) }}
                    />
                    <div className="text-end mt-10">
                      <Link
                        className="readon orange-btn main-home text-capitalize"
                        to="/vice-chancellor-message"
                      >
                        See more
                      </Link>
                    </div>
                    {/* Section Title End */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-7">
              <div className="about-content">
                {/* Section Title Start */}
                <SectionTitle
                  sectionClass="sec-title"
                  subtitleClass="sub-title orange text-capitalize"
                  subtitle={data?.data?.attributes?.Title || ""}
                  titleClass=""
                  title=""
                  descClass=""
                  description=""
                />
                <BlocksRenderer content={data2 || []} />
                <div className="text-end mt-10">
                  <Link
                    className="readon orange-btn main-home text-capitalize"
                    to="/about"
                  >
                    See more
                  </Link>
                </div>
                {/* Section Title End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutText;
